<template>
  <el-row :gutter="20">
    <el-col :span="12" :offset="6">
      <el-form
        ref="firmForm"
        :model="firmForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="版本类型" prop="versionType">
          <el-select
            v-model="firmForm.versionType"
            placeholder="请选择版本类型"
          >
            <el-option
              v-for="item in versionTypes"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="projetId">
          <el-select
            v-model="firmForm.projetId"
            filterable
            @change="handlePorjectChange"
            v-el-select-loadmore="loadMore"
            placeholder="请选择所属项目"
          >
            <el-option
              v-for="item in project.list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="升级设备" prop="devicesSn">
          <el-select
            v-model="firmForm.devicesSn"
            filterable
            multiple
            collapse-tags
            v-el-select-loadmore="loadMoreDevice"
            placeholder="请选择需要升级的设备"
          >
            <el-option
              v-for="item in devices.list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="固件版本" prop="version">
          <el-input
            v-model="firmForm.version"
            style="width: 70%;"
            placeholder="请输入固件版本"
          ></el-input>
        </el-form-item>
        <el-form-item label="固件描述" prop="desc">
          <el-input
            v-model="firmForm.desc"
            style="width: 70%;"
            placeholder="请输入固件描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本发布说明" prop="releaseNote">
          <el-input
            v-model="firmForm.releaseNote"
            style="width: 70%;"
            placeholder="请输入版本发布说明"
          ></el-input>
        </el-form-item>

        <el-form-item label="固件A上传" prop="fileA">
          <el-upload
            class="upload"
            ref="uploadA"
            :file-list="firmForm.fileListA"
            drag
            :auto-upload="false"
            :limit="1"
            accept=".bin"
            action="/upload"
            :on-change="handleFileChangeA"
            :on-remove="handleFileRemoveA"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将 A 分区固件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传bin格式文件，且不超过2M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="固件B上传" prop="fileB">
          <el-upload
            class="upload"
            ref="uploadB"
            :file-list="firmForm.fileListB"
            drag
            :auto-upload="false"
            :limit="1"
            accept=".bin"
            action="/upload"
            :on-change="handleFileChangeB"
            :on-remove="handleFileRemoveB"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将 B 分区固件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传bin格式文件，且不超过2M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="success" plain @click="onSubmit('firmForm')"
            >保存</el-button
          >
          <el-button type="info" @click="onCancle" plain>取消</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>
<script>
import { calculateMD5 } from "@/utils/md5";
import { get } from "jquery";
import { version } from "less";
export default {
  name: "AddFirmware",
  data() {
    return {
      versionTypes: [],
      project: {
        count: 0,
        list: [],
        pageNo: 1
      },
      devices: {
        projectId: "",
        count: 0,
        list: [],
        pageNo: 1
      },
      rules: {
        versionType: [
          { required: true, message: "请选择版本类型", trigger: "change" }
        ],
        projetId: [
          { required: true, message: "请选择所属项目", trigger: "change" }
        ],
        devicesSn: [
          { required: true, message: "请选择需要升级的设备", trigger: "change" }
        ],
        version: [
          { required: true, message: "请输入固件版本", trigger: "blur" }
        ],
        releaseNote: [
          { required: true, message: "请输入版本发布说明", trigger: "blur" }
        ],
        fileA: [
          { required: true, message: "请上传 A 分区固件", trigger: ["change", "blur"] }
        ],
        fileB: [
          { required: true, message: "请上传 B 分区固件", trigger: ["change", "blur"] }
        ]
      },
      firmForm: {
        versionType: "",
        projetId: "",
        devicesSn: [],
        version: "",
        desc: "",
        releaseNote: "",
        fileListA: [],
        fileA: null,
        fireMD5A: "",
        fileListB: [],
        fileB: null,
        fireMD5B: ""
      }
    };
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          if (scrollHeight - scrollTop == clientHeight) {
            binding.value(); // 触发加载更多
          }
        });
      }
    }
  },
  methods: {
    getVersionType() {
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/versionType",
        method: "GET",
        callback: response => {
          this.versionTypes = response;
        }
      });
    },
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));

          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },
    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
        console.log("loadMore!");
      }
    },
    handlePorjectChange(value) {
      this.devices.list = [];
      this.devices.projetId = value;
      this.getDevices(this.devices.projetId, this.devices.pageNo);
    },
    loadMoreDevice() {
      if (this.devices.list.length < this.devices.count) {
        this.devices.pageNo++;
        this.getDevices(this.devices.projetId, this.devices.pageNo);
        console.log("loadMoreDevice!");
      }
    },

    getDevices(projectId, pageNo) {
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/dcDevice/page",
        data: {
          projectID: projectId,
          pageNo: pageNo,
          pageSize: 10
        },
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.SN,
            label: item.SN
          }));
          this.devices.list = [...this.devices.list, ...filteredList];
          this.devices.count = response.count;
        }
      });
    },
    validateFile(file) {
      const isBin = file.name.endsWith(".bin");
      const isLt2M = file.size <= 480 * 1024;
      if (!isBin) {
        this.$message.error("只能上传 bin 格式文件");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("文件大小不能超过 2M");
        return false;
      }
      return true;
    },
    async handleFileChangeA(file, fileList) {
      if (!this.validateFile(file.raw)) {
        this.$refs.uploadA.clearFiles();
        this.firmForm.fileA = null;
        return;
      }
      this.firmForm.fileA = file;
      this.firmForm.fileListA = fileList;
      this.firmForm.fireMD5A = await calculateMD5(file.raw);
    },
    handleFileRemoveA() {
      this.firmForm.fileA = null;
      this.firmForm.fileListA = [];
      this.firmForm.fireMD5A = "";
    },
    async handleFileChangeB(file, fileList) {
      if (!this.validateFile(file.raw)) {
        this.$refs.uploadB.clearFiles();
        this.firmForm.fileB = null;
        return;
      }
      this.firmForm.fileB = file;
      this.firmForm.fileListB = fileList;
      this.firmForm.fireMD5B = await calculateMD5(file.raw);
    },
    handleFileRemoveB() {
      this.firmForm.fileB = null;
      this.firmForm.fileListB = [];
      this.firmForm.fireMD5B = "";
    },
    onSubmit(formName) {
      console.log(this.firmForm);
      this.$refs[formName].validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("versionType", this.firmForm.versionType);
          formData.append("projectId", this.firmForm.projetId);
          formData.append("deviceSn", this.firmForm.devicesSn.join(","));
          formData.append("version", this.firmForm.version);
          formData.append("desc", this.firmForm.desc);
          formData.append("releaseNote", this.firmForm.releaseNote);
          formData.append("fileA", this.firmForm.fileA.raw);
          formData.append("firmMd5A", this.firmForm.fireMD5A);
          formData.append("fileB", this.firmForm.fileB.raw);
          formData.append("firmMd5B", this.firmForm.fireMD5B);
          this.$store.dispatch("firmware/handleRequest", {
            url: "/battery/ota/upload",
            data: formData,
            method: "POST",
            callback: response => {
              this.$notify({
                title: "提示",
                message: "新增固件成功（A/B 双固件）",
                type: "success"
              });
              this.$refs.uploadA.clearFiles();
              this.$refs.uploadB.clearFiles();
              this.$refs.firmForm.resetFields();
              this.firmForm.fireMD5A = "";
              this.firmForm.fireMD5B = "";
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onCancle() {
      console.log("cancle!");
      this.$router.back();
    }
  },
  mounted() {
    // console.log("mounted!");
  },
  created() {
    // console.log("created!");
  },
  beforeCreate() {
    // console.log("beforeCreate!");
  }, //生命周期 - 创建之前
  beforeMount() {
    // console.log("beforeMount!");
    this.getVersionType();
    this.getProjects(this.project.pageNo);
  }, //生命周期 - 挂载之前
  beforeUpdate() {
    // console.log("beforeUpdate!");
  }, //生命周期 - 更新之前
  updated() {
    // console.log("updated!");
  }, //生命周期 - 更新之后
  beforeDestroy() {
    // console.log("beforeDestroy!");
  }, //生命周期 - 销毁之前
  destroyed() {
    // console.log("destroyed!");
  }, //生命周期 - 销毁完成
  activated() {
    // console.log("activated!");
  } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/BMS/otaManager/addFirmware.vue